// extracted by mini-css-extract-plugin
module.exports = {"captchaError":"AuthenticationForm_captchaError__QfqU9","message":"AuthenticationForm_message__T4m4c"};